import api from '@/sui/api/api'

let module = null

const remote = true
if (remote) {
  module = {
    add (request) {
      return api.post('sheet/toolsusage/addOrUpdate', request)
    },

    get (request) {
      return api.post('sheet/toolsusage/get', request)
    },

    updateStatus (request) {
      return api.post('sheet/toolsusage/status', request)
    }
  }
}

export default module
